import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AdminAuthProvider, useAdminAuth } from "./context/AdminAuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import NosStoresPage from "./pages/NosStoresPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ContactPage from "./pages/ContactPage";
import QuiSommesNousPage from "./pages/QuiSommesNousPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthCallback from "./pages/AuthCallback";
import DashboardPage from "./pages/DashboardPage";
import TuilesPage from "./pages/TuilesPage";
import MarquagePage from "./pages/MarquagePage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";

// Protected route for pro users
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" state={{ from: location }} replace />;
  return children;
};

// Protected route for admin
const AdminRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin" replace />;
  return children;
};

// Layout with header/footer
const WithLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<WithLayout><HomePage /></WithLayout>} />
      <Route path="/nos-stores" element={<WithLayout><NosStoresPage /></WithLayout>} />
      <Route path="/produit/:slug" element={<WithLayout><ProductDetailPage /></WithLayout>} />
      <Route path="/contact" element={<WithLayout><ContactPage /></WithLayout>} />
      <Route path="/qui-sommes-nous" element={<WithLayout><QuiSommesNousPage /></WithLayout>} />

      {/* Auth */}
      <Route path="/connexion" element={<LoginPage />} />
      <Route path="/inscription" element={<RegisterPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Pro (protected) */}
      <Route path="/mon-espace" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/toiles-sur-mesure" element={<ProtectedRoute><TuilesPage /></ProtectedRoute>} />
      <Route path="/marquage" element={<ProtectedRoute><MarquagePage /></ProtectedRoute>} />

      {/* Admin */}
      <Route path="/admin" element={<AdminLoginPage />} />
      <Route path="/admin/*" element={<AdminRoute><AdminLayout /></AdminRoute>} />

      {/* Fallback */}
      <Route path="*" element={<WithLayout><HomePage /></WithLayout>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AuthProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
